import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { Checkbox, createFilterOptions } from '@mui/material'
import { default as TextFieldMui } from '@mui/material/TextField'
import { Autocomplete, AutocompleteProps } from './Autocomplete'

export interface CountriesAutoCompleteProps
  extends Omit<AutocompleteProps, 'options' | 'renderInput'> {
  countryData: any
  selectedCountries: any
}

export const CountriesAutocomplete = ({
  name,
  countryData,
  selectedCountries,
  ...rest
}: CountriesAutoCompleteProps) => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
  const checkedIcon = <CheckBoxIcon fontSize="small" />

  const countryFilterOptions = createFilterOptions({
    ignoreCase: true,
    stringify: (option: any) => option.code + option.name,
  })

  return (
    <Autocomplete
      name={name}
      multiple
      options={countryData}
      limitTags={3}
      disableCloseOnSelect
      disablePortal
      filterOptions={countryFilterOptions}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      getOptionLabel={(option) => option.code}
      value={selectedCountries}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option?.name} ({option?.code})
        </li>
      )}
      renderInput={(params) => (
        <TextFieldMui
          {...params}
          placeholder={
            selectedCountries && selectedCountries.length === 0 ? 'Select Ship To Country' : ''
          }
        />
      )}
      {...rest}
    />
  )
}
